import { useStaticQuery, graphql } from "gatsby";

/**
 * Ítems de la navegación principal, según el documento de home:
 *
 *   Público:     Inicio · Productos · Marcas · Promociones · Contacto
 *   Con sesión:  Inicio · Productos · Lista de precios · Marcas · Promociones · Contacto
 *
 * "Productos" está siempre y entra por la primera categoría. Que existan al
 * menos una categoría está garantizado: en desarrollo `gatsby-node.js` carga el
 * catálogo de prueba cuando la API no responde, y en producción el build aborta
 * si la API no devolvió categorías.
 *
 * "Lista de precios" necesita además el perfil que guarda el login. Marcas,
 * Promociones y Contacto son anclas de la home y funcionan desde cualquier página.
 */
const useNavItems = ({ hasPriceList = false } = {}) => {

	const categories = useStaticQuery(graphql`
        query NavCategories {
            allCategories(limit: 1, sort: {fields: category}) {
                nodes {
                    categorySlug
                }
            }
        }
    `).allCategories.nodes;

	const firstCategorySlug = categories[0]?.categorySlug;

	return [
		{ caption: "Inicio", href: "/" },
		{
			caption: "Productos",
			href: `/categoria/${firstCategorySlug}`,
			isCategoryLink: true
		},
		...(hasPriceList
			? [{ caption: "Lista de precios", href: "/lista-de-precios" }]
			: []),
		{ caption: "Marcas", href: "/#marcas" },
		{ caption: "Promociones", href: "/#promociones" },
		{ caption: "Contacto", href: "/#contacto" }
	];
};

export default useNavItems;
